import React from "react";

import { Tag } from "@chakra-ui/react";

const PassTag = (props) => {
  return (
    <Tag
      size="sm"
      key="sm"
      variant="solid"
      background={"#309C443f"}
      textColor={"#309C44"}
      borderRadius={"1.375rem"}
    >
      {props.status_tag}
    </Tag>
  );
};

const FailTag = (props) => {
  return (
    <Tag
      size="sm"
      key="sm"
      variant="solid"
      background={"#FF00003f"}
      textColor={"#FF0000"}
      borderRadius={"1.375rem"}
    >
      {props.status_tag}
    </Tag>
  );
};

const RunningTag = (props) => {
  return (
    <Tag
      size="sm"
      key="sm"
      variant="solid"
      background={"#FDE499"}
      textColor={"#896804"}
      borderRadius={"1.375rem"}
    >
      {props.status_tag}
    </Tag>
  );
};

export default function AlgorithmStatus(props) {
  const { status_text } = props;

  if (!(typeof status_text === "string")) {
    return;
  }

  if (
    status_text &&
    (status_text.toLowerCase().includes("pass") ||
      status_text.toLowerCase().includes("one file"))
  ) {
    return <PassTag status_tag={status_text} />;
  }

  if (status_text && status_text.toLowerCase().includes("fail")) {
    return <FailTag status_tag={status_text} />;
  }

  if (status_text && status_text.toLowerCase().includes("running")) {
    return <RunningTag status_tag={status_text} />;
  }

  return <></>;
}
